<template>
  <div>
    <v-row>
      <v-col>
        <v-dialog v-model="dialog" persistent max-width="600px">
          <v-card>
            <v-card-title>
              <span class="headline"> {{ saveType }} Document Category </span>
            </v-card-title>
            <v-card-text>
              <v-container>
                <v-row>
                  <v-col cols="12">
                    <v-text-field
                      aria-autocomplete="off"
                      label="Name*"
                      v-model="name"
                      required
                    ></v-text-field>
                  </v-col>
                  
                </v-row>
                <v-switch
                  v-model="toggleCategoryGroup"
                  :label="categoryGroup"
                ></v-switch>
                <v-col cols="12" v-if="errorMessage">
                    <h3 class="text-center red--text">
                      {{ errorMessage }}
                    </h3>
                  </v-col>
              </v-container>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="blue darken-1" text @click="close(false, `Close`)"
                >Close</v-btn
              >
              <v-btn color="blue darken-1" text @click="save()">Save</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-col>
    </v-row>
    <loading-overlay v-if="loading"/>
  </div>
</template>

<script>
  import { mapActions } from "vuex";
  import LoadingOverlay from "../common/LoadingOverlay.vue";

  export default {
    name: "DocumentCategorCreateDialog",
    props: {
      dialog: Boolean,
      saveType: String,
      categoryUpdate: Object,
    },
    components: {
      LoadingOverlay
    },
    data() {
      return {
        loading: false,
        toggleCategoryGroup: false,
        categoryGroup: "Incoming",
        name: "",
        errorMessage: ""
      };
    },
    methods: {
      ...mapActions(["createDocumentCategory", "updateDocumentCategory"]),
      save() {
        this.loading = true;
        const body = {
          name: this.name,
          classification: this.categoryGroup == "Incoming" ? 1 : 2
        };

        if (this.saveType === "Update") {
          body.id = this.categoryUpdate.id;

          this.updateDocumentCategory(body).then((res) => {
            this.loading = false;
            if (res.error) {
              if (res.status === 400) {
                this.errorMessage = res.message
              }
            } else {
              this.close(true, "Update");
            }
          });
        } else {
          this.createDocumentCategory(body).then((res) => {
            this.loading = false;
            if (res.error) {
              if (res.status === 400) {
                this.errorMessage = res.message
              }
            } else {
              this.close(true, "Create");
            }
          });
        }
      },
      close(val, action) {
        this.name = "";
        this.$emit("closeDialog", val, action);
      },
    },
    watch: {
      toggleCategoryGroup() {
        if(this.toggleCategoryGroup){
          this.categoryGroup = "Outgoing"
        }else{
          this.categoryGroup = "Incoming"
        }
      },
      dialog() {
        if (this.saveType === "Update") {
          this.name = this.categoryUpdate.name;
        }
      },
    },
  };
</script>

<style></style>
